import React from "react";
import Swal from "sweetalert2";

const ConfirmationModal = async ({
  title = "Вы уверены?",
  text = "Это действие нельзя отменить.",
  icon = "warning",
  confirmButtonText = "Да, выполнить!",
  cancelButtonText = "Нет, отмена!",
  confirmButtonColor = "#d33",
  cancelButtonColor = "#3085d6",
  onConfirm = () => {},
  onCancel = () => {},
  successTitle = "Выполнено!", 
  successText = "Действие успешно выполнено.", 
  successIcon = "success",
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor,
    cancelButtonColor,
  });

  if (result.isConfirmed) {
    try {
      await onConfirm(); 
      Swal.fire({
        title: successTitle,
        text: successText,
        icon: successIcon,
      });
    } catch (error) {
    }
  } else if (result.dismiss === Swal.DismissReason.cancel) {
    onCancel();
  }
};

export default ConfirmationModal;
